import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 76,
	height: 100,
	viewBox: "0 0 76 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_540_3101)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M45.319 44.5738C43.6803 44.5738 42.4591 45.3919 42.4591 47.3592C42.4591 48.8413 43.2628 49.8712 45.2306 49.8712C46.8988 49.8712 48.032 48.874 48.032 47.298C48.032 45.5126 47.018 44.5738 45.319 44.5738ZM42.0416 58.4695C41.6536 58.9529 41.2669 59.4677 41.2669 60.0736C41.2669 61.2841 42.7854 61.6472 44.8721 61.6472C46.6019 61.6472 48.9563 61.5248 48.9563 59.8931C48.9563 58.9216 47.8234 58.8618 46.3919 58.7707L42.0416 58.4695ZM50.8638 44.6649C51.3991 45.362 51.9666 46.3307 51.9666 47.7234C51.9666 51.082 49.3738 53.0507 45.6186 53.0507C44.6635 53.0507 43.7995 52.9296 43.2628 52.7776L42.2799 54.3822L45.1998 54.563C50.357 54.8969 53.3964 55.0493 53.3964 59.0736C53.3964 62.5547 50.3865 64.5223 45.1998 64.5223C39.806 64.5223 37.7488 63.1296 37.7488 60.738C37.7488 59.3756 38.3454 58.651 39.3888 57.65C38.4043 57.2288 38.0779 56.4719 38.0779 55.6538C38.0779 54.9881 38.4043 54.3822 38.9419 53.8062C39.4782 53.2316 40.0738 52.6566 40.7895 51.9909C39.3299 51.2639 38.2262 49.6893 38.2262 47.4489C38.2262 43.9679 40.4909 41.5776 45.0515 41.5776C46.333 41.5776 47.1077 41.6973 47.794 41.8809H53.6063V44.4528L50.8642 44.6649",
				fill: "#362701"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_540_3101",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 54,
				y: 33,
				width: 10,
				height: 25,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M54.9509 33.7749H63.5126V57.5001H54.9509V33.7749Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_540_3101)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M58.849 39.1629C57.15 39.1629 56.1668 38.1647 56.1668 36.4374C56.1668 34.7132 57.15 33.7744 58.849 33.7744C60.5785 33.7744 61.562 34.7135 61.562 36.4374C61.562 38.1643 60.5788 39.1629 58.849 39.1629ZM55.0042 57.356V54.9643L56.524 54.7535C56.9415 54.6927 57.0014 54.6015 57.0014 54.1462V45.2471C57.0014 44.9156 56.912 44.7024 56.6137 44.6127L55.0042 44.0367L55.3319 41.5855H61.5018V54.1469C61.5018 54.6335 61.5312 54.693 61.9795 54.7542L63.499 54.965V57.3563L55.0042 57.356Z",
					fill: "#362701"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask1_540_3101",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 63,
				y: 36,
				width: 13,
				height: 22,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M63.1694 36.6309H75.2828V57.5004H63.1694V36.6309Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask1_540_3101)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M75.2848 56.1818C74.0033 56.8166 72.1262 57.3926 70.4262 57.3926C66.8797 57.3926 65.5393 55.9404 65.5393 52.5178V44.5884C65.5393 44.4062 65.5393 44.2855 65.2995 44.2855H63.2129V41.5912C65.8375 41.2882 66.8797 39.9554 67.2074 36.6562H70.0396V40.9554C70.0396 41.1672 70.0396 41.258 70.2776 41.258H74.4797V44.2855H70.0396V51.5192C70.0396 53.3056 70.4567 54.0013 72.0663 54.0013C72.9009 54.0013 73.7649 53.7895 74.4797 53.5178L75.2848 56.1818Z",
					fill: "#362701"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask2_540_3101",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 33,
				width: 33,
				height: 33,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0.499756 33.7749H32.0066V65.5001H0.499756V33.7749Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask2_540_3101)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M31.124 48.2375L17.4963 34.3979C17.3097 34.2083 17.0881 34.0579 16.8443 33.9552C16.6004 33.8526 16.339 33.7998 16.0751 33.7998C15.8111 33.7998 15.5497 33.8526 15.3059 33.9552C15.062 34.0579 14.8404 34.2083 14.6538 34.3979L11.824 37.2716L15.4131 40.9182C15.835 40.7721 16.2888 40.749 16.723 40.8516C17.1572 40.9541 17.5544 41.1782 17.8696 41.4984C18.1863 41.8206 18.4074 42.2268 18.5077 42.6705C18.608 43.1143 18.5834 43.5777 18.4367 44.0079L21.8963 47.5227C22.3198 47.3732 22.7762 47.3479 23.2132 47.4499C23.6502 47.5518 24.05 47.7768 24.3668 48.0991C24.5892 48.3244 24.7656 48.5921 24.8859 48.8868C25.0063 49.1815 25.0682 49.4974 25.0682 49.8165C25.0682 50.1355 25.0063 50.4514 24.8859 50.7461C24.7656 51.0408 24.5892 51.3085 24.3668 51.5339C24.1448 51.7597 23.8811 51.9389 23.5909 52.0611C23.3006 52.1834 22.9895 52.2463 22.6752 52.2463C22.361 52.2463 22.0499 52.1834 21.7596 52.0611C21.4693 51.9389 21.2056 51.7597 20.9836 51.5339C20.6501 51.1947 20.4228 50.763 20.3302 50.2931C20.2377 49.8231 20.284 49.3358 20.4634 48.8925L17.2367 45.6152V54.2389C17.4709 54.3558 17.6847 54.5109 17.8696 54.698C18.3181 55.1538 18.5701 55.7719 18.5701 56.4163C18.5701 57.0607 18.3181 57.6788 17.8696 58.1346C16.9347 59.0827 15.4199 59.0827 14.4877 58.1346C14.2653 57.9091 14.0889 57.6412 13.9685 57.3464C13.8481 57.0515 13.7861 56.7355 13.7861 56.4163C13.7861 56.0971 13.8481 55.781 13.9685 55.4862C14.0889 55.1914 14.2653 54.9235 14.4877 54.698C14.711 54.4699 14.9771 54.2898 15.2703 54.1683V45.4643C14.9771 45.3428 14.711 45.1626 14.4877 44.9346C14.152 44.5937 13.9236 44.1592 13.8316 43.6862C13.7396 43.2132 13.7883 42.7231 13.9713 42.2782L10.4329 38.6831L1.08876 48.1735C0.902031 48.3631 0.753902 48.5881 0.652838 48.8358C0.551774 49.0835 0.499756 49.349 0.499756 49.6172C0.499756 49.8853 0.551774 50.1508 0.652838 50.3985C0.753902 50.6462 0.902031 50.8713 1.08876 51.0608L14.7165 64.9019C14.9031 65.0915 15.1247 65.2419 15.3685 65.3445C15.6124 65.4471 15.8738 65.4999 16.1377 65.4999C16.4017 65.4999 16.6631 65.4471 16.9069 65.3445C17.1508 65.2419 17.3724 65.0915 17.559 64.9019L31.124 51.1262C31.5012 50.7431 31.713 50.2236 31.713 49.6819C31.713 49.1401 31.5012 48.6206 31.124 48.2375Z",
					fill: "#F03C2E"
				})
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_540_3101",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 75,
			height: 32,
			fill: "white",
			transform: "translate(0.5 33.5)"
		})
	}) })]
});
export default SvgGit;
